<template>
  <div
    style="background: #ffffffb0; position: absolute; z-index: 1; top: 0; right: 15px; bottom: 0; left: 15px;"
  >
    <div style="position: absolute;left: 50%; top: 50%;margin-top: -28px; margin-left: -25px">
      <div class="spinner text-xs-center">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {}
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/DashboardGraphLoading.vue